import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const ExpireLabel = styled("span")(({ expired }: { expired: boolean }) => ({
  color: expired ? colors.error600 : colors.gray600,
}));

export const ColumnStatus = styled("div")(() => ({
  position: "relative",
  left: "-2px",
  "& > div": {
    width: "fit-content",
  },
}));
